import {Core, HybirdBridge} from "./core";

let _bridge;

/**
 * 直接设置指定的bridge
 * @param bridge{Core} 继承Bridge
 */
async function setBridge(bridge) {
  if (bridge instanceof Core) {
    _bridge = bridge;
  } else {
    throw new Error(`not support ${typeof bridge}, use Bridge`);
  }
}

/**
 * 获取bridge
 * @return {Promise<Core>}
 */
async function getBridge() {
  if (!_bridge) {
    throw new Error("not support bridge, please setBridge");
  }

  return _bridge;
}

/**
 * 调用方法
 * @param name{String} 方法名
 * @param params{{}} 方法参数
 * @param namespace 命名空间
 * @param callback
 * @param cancelFnCall
 * @param on
 * @param parseResult 是否解析结果, 默认解析
 * @return {Promise<Object>}//当前方法返回的对象信息
 * }>} 方法返回的参数
 */
function invoke(name, {
  params = {},
  namespace = "",
  callback = null,
  cancelFnCall = null,
  on = {},
  parseResult = true
} = {}) {
  return getBridge().then(async _bridge => {
    return _bridge.invoke(name, params, {namespace, callback, cancelFnCall, on, parseResult});
  });
}

/**
 * 监听方法
 * @param name{String} 监听的名称
 * @param event{function({})} 事件
 * @param params{{}} 方法参数
 * @param namespace{String} 命名空间
 * @param filter(function:boolean) 过滤
 * @param isOne
 * @param isSend
 * @return {Promise<{cancel:function}>} eventId
 */
function on(name, event, {
  params = {},
  namespace = "",
  filter,
  isOne = false,
  isSend = false,
  off = name.replace("on", "off")
} = {}) {
  return getBridge().then(async _bridge => {
    return _bridge.on(name, event, {params, namespace, filter, isOne, isSend, off});
  });
}

/**
 * 取消监听
 * @param name{String} 监听的名称
 * @param event{function({})} 事件
 * @param namespace{String} 命名空间
 * @param isSend
 * @param off 关闭的名称
 * @param params
 */
function cancel(name, {event, namespace = "", isSend = false, off = name.replace("on", "off"), params} = {}) {
  return getBridge().then(async _bridge => {
    _bridge.off(name, {event, namespace, isSend, off, params});
  });
}

/**
 * 准备完成后执行
 * @param event{function()} 事件
 */
function ready(event) {
  return getBridge().then(async _bridge => {
    await _bridge.ready(event);
  });
}

export {on, cancel, ready, invoke, setBridge, getBridge, HybirdBridge};

